/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {
  Component,
  Input,
  ChangeDetectionStrategy
} from '@angular/core';
import {PartNumberChangesCancellationConfigurationModel} from '../services/part-number-changes-detail-configuration/models/cancellation/part-number-changes-cancellation-configuration.model';

@Component({
    selector: 'app-part-number-changes-cancellation',
    templateUrl: './part-number-changes-cancellation.component.html',
    styleUrls: [
        '../styles/pnc-base.component.css',
        './part-number-changes-cancellation.component.css'
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class PartNumberChangesCancellationComponent {
    @Input() configuration: PartNumberChangesCancellationConfigurationModel;
}
